export default __webpack_public_path__ + "static/media/Folder.26b52e5d.svg";